var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tooltip',{attrs:{"disabled":!_vm.disabledByValidation,"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-card',_vm._g(_vm._b({staticClass:"ma-1",class:[
        !_vm.disabledOpen ? 'inspection-card' : '',
        _vm.open ? 'active' : '',
        _vm.disabledOpen ? 'normal-cursor' : ''
      ],attrs:{"width":"114","height":"103","max-height":"103","max-width":"114","ripple":_vm.ripple},on:{"click":_vm.openCard}},'v-card',attrs,false),on),[_vm._t("default")],2)]}}],null,true)},[_c('span',[_vm._v("Validado por el supervisor")])])
}
var staticRenderFns = []

export { render, staticRenderFns }